import { createAction, props } from '@ngrx/store';
import { DiningAttribute } from '@shared/models/dining-attribute';
import { DiningResultsLayout } from '@shared/models/dining-results-layout.enum';

export const setDiningLayout = createAction(
  '[Dining] Set dining results layout',
  props<{ layout: DiningResultsLayout }>()
);

export const diningAttributesLoaded = createAction(
  '[Dining] Dining attributes loaded',
  props<{ attributes: DiningAttribute[] }>()
);

export const setHeaderHeight = createAction('[Dining] Set header height', props<{ height: number }>());
